<!--
 * @Description: ================== 游戏介绍 =================
 * @Date: 2022-05-13 18:08:07
 * @Author: Zero
 * @FilePath: \guobao-web\src\components\Game.vue
 * @LastEditors: Zero
 * @LastEditTime: 2022-06-14 14:51:49
-->
<template>
  <div class="page page-game">
    <div style="margin-top:20px">
      <img src="/banner.jpg" alt="" style="width: 100%" />
    </div>
    <h2 class="title">游戏介绍</h2>
    <p>《最强武装》完美集结历代高达机体，1:1还原经典战役，点燃宇宙世纪之魂！在殖民卫星的纷争中，成为传奇机师，率领小队对抗吉翁残党，迎战终极BOSS「夏亚」，书写属于你的高达史诗！</p>
    <!-- <pre> -->
    <h2 class="title" style="margin-bottom: 0px">游戏特色</h2>
    <div class="content">
      <div class="content-item">
        <h4>【极致还原 高达之魂觉醒】</h4>
        全3D高精度建模，震撼必杀动画演出，从元祖高达到独角兽，百款机体悉数登场，名场景高清重现，原作台词原声收录！
        <img src="/1.jpg" alt="" />
      </div>
      <div class="content-item">
        <h4>【战术微操 以智取胜】</h4>
        机体属性克制，小队编成羁绊，阵型策略布局，搭配养成系统突破战力极限。新人类觉醒，一招逆转战局！
        <img src="/2.jpg" alt="" />
      </div>
      <div class="content-item">
        <h4>【宇宙探索 秘境试炼】</h4>
        陨石带突围、新类型人特训，多重试炼解锁隐藏机能，收集专属机师与羁绊机体强强联合！
        <img src="/3.jpg" alt="" />
      </div>
      <div class="content-item">
        <h4>【万抽免费送 联邦大礼】</h4>
        次日登录即送SSR级「V高达」，每日十连免费送，高级机体轻松获得，零氪全收集不是梦！
        <img src="/4.jpg" alt="" />
      </div>
    </div>
    <!-- </pre> -->
  </div>
</template>

<style scss>
.content-item {
  display: inline-block;
  width: 50%;
  padding: 12px;
  box-sizing: border-box;
  vertical-align: top;
}
.content-item img {
  display: block;
  margin-top: 12px;
  width: 400px;
}
@media screen and (max-width: 768px) {
  .content-item {
    width: 100%;
  }
  .content-item img {
    width: 100%;
  }
}
</style>
